// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sh-pricing__prices-cont[data-v-d3e88854] {\n  margin-bottom: 30px;\n}\n.sh-pricing__report[data-v-d3e88854] {\n  margin-bottom: 10px;\n}\n.sh-pricing__overlay-note[data-v-d3e88854] {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  font-weight: bold;\n  font-size: 55px;\n  text-transform: uppercase;\n  opacity: 0.4;\n  cursor: default;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
module.exports = exports;
